import BlockComponentButton from '../BlockComponentValues/BlockComponentButton';
import BlockComponentImage from '../BlockComponentValues/BlockComponentImage';
import BlockComponentText from '../BlockComponentValues/BlockComponentText';

export enum BlockCardVariant {
  Left = 'left',
  Right = 'right',
}

class BlockCardData {
  variant: BlockCardVariant;
  title?: BlockComponentText;
  descriptionHeader?: BlockComponentText;
  descriptionSubHeader?: BlockComponentText;
  descriptionBody?: BlockComponentText;
  mainImage?: BlockComponentImage;
  backgroundImage?: BlockComponentImage;
  button?: BlockComponentButton;
}

// eslint-disable-next-line @typescript-eslint/no-namespace
namespace BlockCardData {
  export function make(
    variant: BlockCardVariant,
    backgroundImage: string,
    title?: string,
    descriptionHeader?: string,
    descriptionSubHeader?: string,
    descriptionBody?: string,
    mainImage?: string,
    button?: BlockComponentButton,
  ): BlockCardData {
    return {
      variant,
      title: title ? BlockComponentText.make(title) : undefined,
      descriptionHeader: descriptionHeader ? BlockComponentText.make(descriptionHeader) : undefined,
      descriptionSubHeader: descriptionSubHeader ? BlockComponentText.make(descriptionSubHeader) : undefined,
      descriptionBody: descriptionBody ? BlockComponentText.make(descriptionBody) : undefined,
      mainImage: BlockComponentImage.make(mainImage),
      backgroundImage: BlockComponentImage.make(backgroundImage),
      button,
    };
  }

  export function getDefault(
    variant = BlockCardVariant.Left,
    image = '',
    title = '見出し',
    descriptionHeader = 'ここをクリックして表示したいテキストを入力してください。',
    descriptionSubHeader = 'ここをクリックして表示したいテキストを入力してください。',
    descriptionBody = 'テキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキスト。',
  ): BlockCardData {
    return make(
      variant,
      undefined,
      `<p><strong style="font-size: 36px;">${title}</strong></p>`,
      `<p>${descriptionHeader}</p>`,
      `<p><strong>${descriptionSubHeader}</strong></p>`,
      `<p>${descriptionBody}</p>`,
      image,
      BlockComponentButton.getDefault(),
    );
  }
}

export default BlockCardData;
